import { toAbsoluteUrl } from "src/_metronic/helpers";
import SVG from "react-inlinesvg";
import React from "react";

const OffSiteStat = (props: { stat: { [key: string]: string }; statName: string }) => {
    const { stat, statName } = props;
    let lastStatsValue = 0;
    const dates = stat && Object.keys(stat);
    const orderDates = dates?.sort((a, b) => {
        const [monthA, yearA] = a.split("/").map(Number);
        const [monthB, yearB] = b.split("/").map(Number);

        return yearA - yearB || monthA - monthB;
    });

    let dateImprovement = {};
    orderDates?.forEach((el) => {
        let currentValue = parseInt(stat[el], 10);
        if (isNaN(currentValue)) {
            currentValue = 0;
        }
        const improvement =
            currentValue >= lastStatsValue ? (currentValue === lastStatsValue ? 0 : 1) : -1;
        lastStatsValue = currentValue;
        dateImprovement = { ...dateImprovement, [el]: improvement };
    });

    const statKeys = stat && Object.keys(stat);
    return (
        <div className="stats stats-smaller">
            <label className="form-label text-center fw-bold-800 text-uppercase">{statName}</label>
            <div className="stats-wrapper">
                {statKeys?.map((el, index) => {
                    const isFirst = index === statKeys.length - 1;
                    let arrow = "arr010";
                    let color = "svg-icon-warning";
                    switch (dateImprovement[el as keyof typeof dateImprovement]) {
                        case -1:
                            arrow = "arr004";
                            color =
                                statName === "Netlinking" ||
                                statName === "Writing" ||
                                statName === "rédaction"
                                    ? "svg-icon-valid"
                                    : "svg-icon-danger";
                            break;
                        case 1:
                            arrow = "arr003";
                            color =
                                statName === "Netlinking" ||
                                statName === "Writing" ||
                                statName === "rédaction"
                                    ? "svg-icon-danger"
                                    : "svg-icon-valid";
                            break;
                        case 0:
                            arrow = "arr090";
                            color = "svg-icon-warning";
                            break;
                    }

                    return (
                        <div className="item" key={index}>
                            <span>{el} :</span>

                            <span className="text-end">
                                {stat[el] || 0}{" "}
                                {(statName === "Writing" ||
                                    statName === "Netlinking" ||
                                    statName === "Average" ||
                                    statName === "PO" ||
                                    statName === "Moy. des ventes" ||
                                    statName === "rédaction") &&
                                    "€"}
                                {!isFirst ? (
                                    <SVG
                                        src={toAbsoluteUrl(
                                            `/media/icons/duotune/arrows/${arrow}.svg`
                                        )}
                                        className={color}
                                    />
                                ) : (
                                    <div
                                        style={{
                                            width: "24px",
                                            display: "inline-block",
                                        }}
                                    />
                                )}
                            </span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default OffSiteStat;
